export const Logo = (props) => {
    const {
        width = 20,
        height = 20,
        foreground = 'var(--f-color-surface)',
        background = 'var(--f-color-accent)',
        ...rest
    } = props

    return (
        <svg
            {...rest}
            width={width}
            height={height}
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M25 12.5C25 2.94118 22.0588 -1.28563e-07 12.5 -5.46392e-07C2.94118 -9.64222e-07 2.37483e-06 2.94118 1.957e-06 12.5C1.53917e-06 22.0588 2.94118 25 12.5 25C22.0588 25 25 22.0588 25 12.5Z"
                //fill="url(#paint0_linear_1552_24)"
                fill={background}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.5 17C14.9853 17 17 14.9853 17 12.5C17 10.0147 14.9853 8 12.5 8C10.0147 8 8 10.0147 8 12.5C8 14.9853 10.0147 17 12.5 17ZM12.5 19C16.0899 19 19 16.0899 19 12.5C19 8.91015 16.0899 6 12.5 6C8.91015 6 6 8.91015 6 12.5C6 16.0899 8.91015 19 12.5 19Z"
                //fill="url(#paint1_linear_1552_24)"
                fill={foreground}
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1552_24"
                    x1="2.31482"
                    y1="2.31766e-07"
                    x2="12.5"
                    y2={25}
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#0078FF" />
                    <stop
                        offset={1}
                        stopColor="#278DFF"
                    />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_1552_24"
                    x1="12.5"
                    y1={6}
                    x2="12.5"
                    y2={19}
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#D6E9FF" />
                    <stop
                        offset={1}
                        stopColor="#E6F2FF"
                    />
                </linearGradient>
            </defs>
        </svg>
    )
}

export const LogoF = ({ size = 0.75, color = 'var(--f-color-accent)' }) => {
    return (
        <svg
            width={57 * size}
            height={93 * size}
            viewBox="0 0 57 93"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            xmlSpace="preserve"
            style={{
                fillRule: 'evenodd',
                clipRule: 'evenodd',
                strokeLinejoin: 'round',
                strokeMiterlimit: 2,
            }}>
            <g transform="matrix(1,0,0,1,-691.735,-380.302)">
                <g transform="matrix(1,0,0,1,0,2.45886)">
                    <g transform="matrix(1,0,0,0.877661,28.2653,54.0524)">
                        <path
                            d="M663.469,462.132C663.469,457.274 666.576,451.716 670.403,449.729C670.403,449.729 687,441.111 690.915,439.078C691.094,438.985 691.303,439.002 691.469,439.124C691.635,439.245 691.735,439.454 691.735,439.679C691.735,442.647 691.735,451.026 691.735,451.026C691.735,455.884 688.628,461.442 684.802,463.428C684.802,463.428 668.537,471.874 664.412,474.016C664.205,474.123 663.966,474.104 663.775,473.964C663.585,473.824 663.469,473.584 663.469,473.326C663.469,470.234 663.469,462.132 663.469,462.132ZM720,409.479C720,413.972 717.127,419.111 713.588,420.949L671.612,442.746C668.207,445.021 665.781,446.325 664.437,448.708C664.319,448.929 664.086,449.034 663.867,448.964C663.648,448.894 663.497,448.667 663.497,448.408C663.469,445.802 663.469,442.479 663.469,442.479L663.469,433.939C663.469,429.446 666.342,424.306 669.881,422.469L711.857,400.672C715.193,398.442 717.59,397.145 718.949,394.853C719.081,394.617 719.334,394.508 719.571,394.587C719.807,394.665 719.969,394.912 719.969,395.192C720,400.259 720,409.479 720,409.479ZM663.469,414.961L663.469,406.204C663.469,401.831 666.266,396.827 669.711,395.038C669.711,395.038 712.19,372.981 719.065,369.41C719.27,369.304 719.508,369.324 719.697,369.462C719.886,369.601 720,369.839 720,370.095C720,373.334 720,382.176 720,382.176C720,386.55 717.203,391.553 713.758,393.342L671.612,415.227C668.137,417.55 665.681,418.86 664.356,421.338C664.251,421.544 664.038,421.644 663.836,421.582C663.634,421.52 663.494,421.312 663.494,421.074C663.469,418.444 663.469,414.961 663.469,414.961Z"
                            style={{ fill: color }}
                        />
                    </g>
                </g>
            </g>
        </svg>
    )
}

export const LogoText = ({ size = 0.75, color = 'var(--f-color-accent)' }) => {
    return (
        <svg
            width={107 * size}
            height={26 * size}
            viewBox="0 0 107 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.876 19.338C4.602 19.338 3.51 18.558 3.146 16.998L0.65 6.26H3.068L5.408 16.504C5.486 16.816 5.59 16.972 5.876 16.972C6.084 16.972 6.24 16.79 6.292 16.556L8.372 8.262C8.762 6.702 9.646 5.948 10.998 5.948C12.35 5.948 13.208 6.676 13.598 8.236L15.652 16.556C15.73 16.816 15.86 16.972 16.12 16.972C16.354 16.972 16.484 16.816 16.562 16.504L18.824 6.26H21.216L18.798 16.998C18.434 18.558 17.368 19.338 16.094 19.338C14.768 19.338 13.884 18.558 13.52 17.024L11.44 8.6C11.362 8.34 11.232 8.184 10.972 8.184C10.738 8.184 10.608 8.34 10.556 8.6L8.45 17.024C8.086 18.558 7.202 19.338 5.876 19.338ZM28.4436 19.286C24.5696 19.286 21.6836 16.478 21.6836 12.552C21.6836 8.886 24.3096 5.896 28.1316 5.896C31.9796 5.896 34.3716 8.678 34.3716 12.24V13.28H24.1796C24.4656 15.464 26.1296 16.998 28.4176 16.998C29.9776 16.998 31.3816 16.322 32.1356 14.918L34.1116 15.932C32.9936 18.116 30.9396 19.286 28.4436 19.286ZM24.2836 11.616H31.7976C31.6936 9.588 30.2116 8.21 28.1056 8.21C25.9476 8.21 24.5436 9.718 24.2836 11.616ZM42.3587 19.286C38.4847 19.286 35.5987 16.478 35.5987 12.552C35.5987 8.886 38.2247 5.896 42.0467 5.896C45.8947 5.896 48.2867 8.678 48.2867 12.24V13.28H38.0947C38.3807 15.464 40.0447 16.998 42.3327 16.998C43.8927 16.998 45.2967 16.322 46.0507 14.918L48.0267 15.932C46.9087 18.116 44.8547 19.286 42.3587 19.286ZM38.1987 11.616H45.7127C45.6087 9.588 44.1267 8.21 42.0207 8.21C39.8627 8.21 38.4587 9.718 38.1987 11.616ZM53.4138 19H50.8398V0.383999H53.4138V11.564H54.9738C55.1038 11.252 55.3118 10.966 55.5718 10.706L59.6538 6.26H62.7998L57.3138 12.24C57.1578 12.37 57.0798 12.474 57.0798 12.604C57.0798 12.734 57.1578 12.838 57.3138 12.968L62.7738 19H59.6018L55.5458 14.554C55.2858 14.242 55.0778 13.93 54.9478 13.592H53.4138V19ZM69.4531 19.312C65.5791 19.312 62.6671 16.322 62.6671 12.656C62.6671 8.782 65.4751 5.948 69.3231 5.948C71.0391 5.948 72.5991 6.702 73.6391 7.846L73.6651 0.409999H76.2391V12.656C76.2391 16.426 73.3011 19.312 69.4531 19.312ZM69.4531 16.894C71.8451 16.894 73.6651 14.97 73.6651 12.63C73.6651 10.316 71.8451 8.392 69.4531 8.392C67.0871 8.392 65.2411 10.316 65.2411 12.63C65.2411 14.97 67.0871 16.894 69.4531 16.894ZM84.4762 19.312C80.7842 19.312 78.0802 16.296 78.0802 12.604C78.0802 8.964 80.9922 5.948 84.8662 5.948C88.7142 5.948 91.6522 8.808 91.6522 12.604V19H89.2082V16.764C88.2462 18.324 86.5562 19.312 84.4762 19.312ZM84.8662 16.868C87.2582 16.868 89.0782 14.944 89.0782 12.63C89.0782 10.29 87.2582 8.366 84.8662 8.366C82.5002 8.366 80.6542 10.29 80.6542 12.63C80.6542 14.944 82.5002 16.868 84.8662 16.868ZM100.123 25.188C97.4194 25.188 95.1834 24.044 94.0394 21.782L96.1714 20.612C96.8994 21.99 98.3294 22.796 100.071 22.796C102.775 22.796 104.179 20.768 104.179 18.012V16.894C103.425 18.324 102.073 19.182 100.149 19.182C96.2494 19.182 94.3514 16.608 94.3514 12.864V6.26H96.8994V12.734C96.8994 15.126 98.1474 16.764 100.461 16.764C102.697 16.764 104.153 14.892 104.153 12.552V6.26H106.753V17.986C106.753 22.25 104.257 25.188 100.123 25.188Z"
                fill={color}
            />
        </svg>
    )
}

export const NewLogoLined = ({ scale = 0.75, color = 'var(--f-color-accent)' }) => {
    return (
        <svg
            width={25 * scale}
            height={28 * scale}
            viewBox="0 0 25 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.483 20.516C5.495 20.611 5.511 20.705 5.53 20.8L6.341 24.774C6.512 25.612 7.007 26.581 8.029 27.119C8.807 27.529 10.104 28 12 28C13.896 28 15.193 27.529 15.971 27.119C16.993 26.581 17.488 25.612 17.659 24.774C17.659 24.774 17.834 23.918 18.021 23C21.875 22.989 25 19.856 25 16C25 13.612 23.802 11.502 21.974 10.238C21.582 4.522 16.815 0 11 0C4.929 0 0 4.929 0 11C0 15.061 2.205 18.611 5.483 20.516ZM7.714 21.5L8.301 24.374C8.371 24.716 8.544 25.13 8.961 25.35C9.556 25.663 10.552 26 12 26C13.448 26 14.444 25.663 15.039 25.35C15.456 25.13 15.629 24.716 15.699 24.374L16.037 22.72C15.236 22.487 14.495 22.113 13.84 21.629C12.934 21.871 11.982 22 11 22C9.856 22 8.752 21.825 7.714 21.5ZM18 11C20.76 11 23 13.24 23 16C23 18.76 20.76 21 18 21C15.24 21 13 18.76 13 16C13 13.24 15.24 11 18 11ZM17.647 4.935C14.953 4.85 12.231 5.835 10.174 7.892C7.011 11.055 6.381 15.792 8.284 19.582C9.141 19.854 10.054 20 11 20C11.407 20 11.808 19.973 12.201 19.92C11.443 18.802 11 17.452 11 16C11 12.137 14.137 9 18 9C18.632 9 19.245 9.084 19.828 9.241C19.503 7.602 18.732 6.123 17.647 4.935ZM15.308 3.098C14.029 2.398 12.561 2 11 2C6.033 2 2 6.033 2 11C2 13.958 3.43 16.585 5.636 18.225C4.536 14.172 5.578 9.66 8.76 6.478C10.611 4.627 12.911 3.501 15.308 3.098Z"
                fill={color}
            />
        </svg>
    )
}

export const LogoNew = ({ scale = 0.5, color = 'rgb(37,43,48)' }) => {
    return (
        <svg
            width={161 * scale * 0.4}
            height={213 * scale * 0.4}
            viewBox="0 0 439 597"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            xmlSpace="preserve"
            style={{
                fillRule: 'evenodd',
                clipRule: 'evenodd',
                strokeLinejoin: 'round',
                strokeMiterlimit: 2,
                transform: 'scaleX(1.2)',
            }}>
            <g transform="matrix(1,0,0,1,-9362.97,202.335)">
                <g transform="matrix(1,0,0,1,2529.05,-1.13687e-13)">
                    <g transform="matrix(3.12007,0,0,3.12007,5309.8,-3670.28)">
                        <g transform="matrix(1.006,-0.299187,-7.53269e-17,1.80293,-1440.64,65.6821)">
                            <path
                                d="M2057.22,925.393C2057.22,922.543 2053.41,920.229 2048.71,920.229L1935.11,920.229C1930.42,920.229 1926.61,922.543 1926.61,925.393L1926.61,949.495C1926.61,952.346 1930.42,954.66 1935.11,954.66L2048.71,954.66C2053.41,954.66 2057.22,952.346 2057.22,949.495L2057.22,925.393Z"
                                style={{ fill: color }}
                            />
                        </g>
                        <g transform="matrix(0.81841,-0.243399,5.6237e-18,1.32926,-1079.24,410.247)">
                            <path
                                d="M2057.22,969.235C2057.22,966.047 2053.35,963.459 2048.6,963.459L1935.23,963.459C1930.47,963.459 1926.61,966.047 1926.61,969.235L1926.61,996.19C1926.61,999.378 1930.47,1001.97 1935.23,1001.97L2048.6,1001.97C2053.35,1001.97 2057.22,999.378 2057.22,996.19L2057.22,969.235Z"
                                style={{ fill: color }}
                            />
                        </g>
                        <g transform="matrix(0.462567,-0.137569,-2.90224e-17,0.8611,-402.694,723.009)">
                            <path
                                d="M2057.22,971.329C2057.22,969.476 2055.59,967.471 2052.82,965.922C2050.06,964.372 2046.48,963.459 2043.17,963.459L1959.16,963.459C1955.13,963.459 1952.41,965.031 1952.5,967.298C1952.59,969.566 1955.47,971.969 1959.54,973.168C1985.21,980.738 2019.83,990.942 2040.21,996.951C2044.29,998.156 2048.63,998.357 2051.95,997.496C2055.27,996.635 2057.22,994.808 2057.22,992.545C2057.22,986.034 2057.22,977.474 2057.22,971.329Z"
                                style={{ fill: color }}
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}
